import { FC, useEffect, useState } from 'react'
import tw from 'twin.macro'
import { Link } from 'gatsby'
import { Grid } from './UI'

import logo from '../images/gabbi-logo-white-r.png'

type Props = {
  headerColor?: 'clear' | 'red' | 'blue'
  headerHoverColor?: 'red' | 'blue'
}

const Header: FC<Props> = ({
  headerColor = 'clear',
  headerHoverColor = 'red',
}) => {
  const [expanded, setExpanded] = useState(false)

  const toggleMobileNav = () => {
    setExpanded(!expanded)
  }

  useEffect(() => {
    document.getElementsByTagName('body')[0].style.overflow = expanded
      ? 'hidden'
      : 'visible'
  }, [expanded])

  return (
    <section
      css={[
        tw`bg-gb-blue absolute top-0 left-0 w-full z-30`,
        headerColor === 'clear' && tw`bg-transparent`,
        headerColor === 'red' && tw`bg-gb-red`,
        headerColor === 'blue' && tw`bg-gb-blue`,
        expanded &&
          tw`fixed bg-gb-red h-screen lg:(block bg-transparent h-auto)`,
      ]}
    >
      {/* Grid */}
      <Grid tw="h-[109px] lg:(h-[126px])">
        {/* Logo */}
        <div tw="col-span-2 flex items-center">
          <Link to="/">
            <img src={logo} tw="w-[148px] lg:w-[163px]" alt="" />
          </Link>
        </div>

        {/* Desktop links */}
        <div tw="hidden lg:(col-start-6 col-span-7 flex items-center justify-end font-domaine text-[19px])">
          <ul tw="text-white flex justify-between">
            <li tw="text-center inline">
              <Link
                to="/#about"
                css={[
                  tw`mx-[20px] w-[85px] inline-block line-height[1] hover:(font-object text-gb-red)`,
                  headerHoverColor === 'blue' && tw`hover:(text-gb-blue)`,
                ]}
              >
                About
              </Link>
            </li>
            <li tw="text-center inline">
              <Link
                to="/blog"
                css={[
                  tw`mx-[20px] w-[70px] inline-block line-height[1] hover:(font-object text-gb-red)`,
                  headerHoverColor === 'blue' && tw`hover:(text-gb-blue)`,
                ]}
              >
                Blog
              </Link>
            </li>
            <li tw="text-center inline">
              <Link
                to="/how-it-works"
                css={[
                  tw`mx-[20px] w-[130px] inline-block line-height[1] hover:(font-object text-gb-red)`,
                  headerHoverColor === 'blue' && tw`hover:(text-gb-blue)`,
                ]}
              >
                How&nbsp;It&nbsp;Works
              </Link>
            </li>
            <li tw="text-center inline">
              <a
                css={[
                  tw`ml-[20px] w-[100px] inline-block border rounded hover:(font-object text-gb-red border-gb-red)`,
                  headerHoverColor === 'blue' &&
                    tw`hover:(text-gb-blue border-gb-blue)`,
                ]}
                href="https://app.gabbi.com/login"
                target="_blank"
                rel="noopener noreferrer"
              >
                Sign&nbsp;in
              </a>
            </li>
          </ul>
        </div>

        {/* Hamburger */}
        <div tw="col-span-2 flex justify-end items-center lg:(hidden)">
          <div tw="mr-4 lg:hidden flex items-center">
            {!expanded && (
              <button onClick={toggleMobileNav}>
                <hr tw="w-7 mb-2 border-white" />
                <hr tw="w-7 my-2 border-white" />
                <hr tw="w-7 mt-2 border-white" />
              </button>
            )}

            {expanded && (
              <button onClick={toggleMobileNav} tw="h-7">
                <hr css={[tw`w-7 border-white rotate-[45deg]`]} />
                <hr css={[tw`w-7 border-white rotate-[-45deg]`]} />
              </button>
            )}
          </div>
        </div>
      </Grid>

      {/* Hamburger Content */}
      <Grid css={[tw`hidden lg:hidden`, expanded && tw`block`]}>
        <ul tw="font-domaine font-normal text-white col-span-3 text-[36px] mt-[30px]">
          <li tw="mb-4">
            <Link to="/#about" onClick={toggleMobileNav}>
              About
            </Link>
          </li>
          <li tw="mb-4">
            <Link to="/blog" onClick={toggleMobileNav}>
              Blog
            </Link>
          </li>
          <li tw="mb-4">
            <Link to="/how-it-works" onClick={toggleMobileNav}>
              How It Works
            </Link>
          </li>
          <li tw="mb-4">
            <a
              href="https://app.gabbi.com/login"
              target="_blank"
              rel="noopener noreferrer"
            >
              Sign in
            </a>
          </li>
        </ul>
      </Grid>
    </section>
  )
}

export default Header
